import { MyWorkTabId, EpicTabId, NoteTabId, Tab } from '@/types/tabs';
import useTranslate from '@/utilities/composables/useTranslate';

const epicDefaultTabs = [
  {
    id: EpicTabId.Details,
    label: 'details',
    icon: 'info',
  },
  {
    id: EpicTabId.Cards,
    label: 'cards',
    icon: 'new-card-icon',
  },
] as Tab[];

const myWorkDefaultTabs = [
  {
    id: MyWorkTabId.Assigned,
    label: 'assignedCards',
  },
  {
    id: MyWorkTabId.Created,
    label: 'createdCards',
  },
] as Tab[];

const noteDefaultTabs = [
  {
    id: NoteTabId.Original,
    label: 'original',
  },
  {
    id: NoteTabId.Enhanced,
    label: 'enhanced',
    icon: 'zap',
  },
] as Tab[];

export default function useTabs() {
  const { translate } = useTranslate();

  const getMyWorkTabs = (selectedTabId: MyWorkTabId, userName: string): Tab[] => {
    return myWorkDefaultTabs.map((t: Tab) => {
      return {
        ...t,
        label: translate(t.label, {
          userName,
        }),
        selected: t.id === selectedTabId,
      };
    });
  };

  const getEpicTabs = (selectedTabId: EpicTabId): Tab[] => {
    return epicDefaultTabs.map((t: Tab) => {
      return {
        ...t,
        label: translate(t.label),
        selected: t.id === selectedTabId,
        hasSlot: t.id === EpicTabId.Cards,
      };
    });
  };

  const getNoteTabs = (
    selectedTabId: NoteTabId,
    enhancedLabel: string,
    dropdownOptions?: any
  ): Tab[] => {
    return noteDefaultTabs.reduce((tabs: Array<Tab>, t: Tab) => {
      tabs.push({
        ...t,
        label: t.id === NoteTabId.Enhanced ? enhancedLabel : translate(t.label),
        selected: t.id === selectedTabId,
        ...(t.id === NoteTabId.Enhanced && { dropdownOptions }),
      });

      return tabs;
    }, []);
  };

  return {
    getMyWorkTabs,
    getEpicTabs,
    getNoteTabs,
  };
}
